import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SearchPipe',
  pure: false
})
export class SearchPipe implements PipeTransform {

  transform(value, args?): Array<any> {
    const searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(conversation => {
        if (conversation.value.name) {
          return conversation.value.name.search(searchText) !== -1;
        }
      });
    }
  }
}
